/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { SiteDto } from '../models/site-dto';
import { siteGetForKiosk } from '../fn/site/site-get-for-kiosk';
import { SiteGetForKiosk$Params } from '../fn/site/site-get-for-kiosk';

@Injectable({ providedIn: 'root' })
export class SiteService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `siteGetForKiosk()` */
  static readonly SiteGetForKioskPath = '/v1/Site/GetForKiosk';

  /**
   * Search Sites,   Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * It will return all matching elements on yours filter criteria
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `siteGetForKiosk()` instead.
   *
   * This method doesn't expect any request body.
   */
  siteGetForKiosk$Response(params?: SiteGetForKiosk$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SiteDto>>> {
    return siteGetForKiosk(this.http, this.rootUrl, params, context);
  }

  /**
   * Search Sites,   Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * It will return all matching elements on yours filter criteria
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `siteGetForKiosk$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  siteGetForKiosk(params?: SiteGetForKiosk$Params, context?: HttpContext): Observable<Array<SiteDto>> {
    return this.siteGetForKiosk$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SiteDto>>): Array<SiteDto> => r.body)
    );
  }

}
